import React from 'react';
import { Box, Botao, Alerta, TipoAlerta, CampoTexto, Form } from "@intechprev/componentes-web";

import { MasterPage } from "..";
import { WebRecadParticipanteDadosEntidade } from '../../entidades';

interface Props {
  RecadDados: WebRecadParticipanteDadosEntidade;
  Avancar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  Patrocinadora: string;
  MatriculaFuncional: string;
  Nome: string;
  CorCheckbox: string;
  checked: boolean;
}

export class Passo1 extends React.Component<Props, State> {

  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Patrocinadora: "",
      MatriculaFuncional: "",
      Nome: "",
      CorCheckbox: "danger",
      checked: false
    }
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      this.setState({
        Patrocinadora: this.props.RecadDados.NOM_EMPRESA,
        MatriculaFuncional: this.props.RecadDados.NUM_MATRICULA,
        Nome: this.props.RecadDados.NOME_ENTID
      });
    }
    catch (e) {
      const err: any = e;
      this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  }

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Início`}>
        <Form>
          <CampoTexto
            valor={this.state.Patrocinadora}
            titulo={"Patrocinadora"}
            contexto={this}
            desabilitado
            nome={"Patrocinadora"}
          />

          <CampoTexto
            valor={this.state.MatriculaFuncional}
            titulo={"Matrícula Funcional"}
            contexto={this}
            desabilitado
            nome={"MatriculaFuncional"}
          />

          <CampoTexto
            valor={this.state.Nome}
            titulo={"Nome"}
            contexto={this}
            desabilitado
            nome={"Nome"}
          />

          <Alerta
            tipo={TipoAlerta.info}
            mensagem={"Antes de iniciar o recadastramento, em caso de alteração, tenha organizado e digitalizado seus documentos, pois será necessário anexar os seguintes comprovantes: RG, certidão de casamento, comprovante de conta corrente e comprovante de recebimento do INSS."}
          />

          <div className={`d-flex align-items-baseline alert alert-${this.state.CorCheckbox}`}>
            <input
              type={"checkbox"}
              id={"manifestacao"}
              name={"manifestacao"}
              checked={this.state.checked}
              onChange={() => {
                this.setState({
                  checked: !this.state.checked,
                  CorCheckbox: !this.state.checked ? "success" : "danger"
                });
              }}
            />
            <label className={"m-2"} htmlFor={"manifestacao"}>
              {"Em observância a Lei 13709/2018, concedo à PREVIRB o direito de usar os meus dados pessoais, por mim fornecidos neste momento, com o objetivo único de manutenção do(s) meu(s) plano(s) previdenciário(s) ao qual faço juz, bem como utilizá-los nas avaliações atuariais e financeiras, podendo ser fornecidos aos órgãos governamentais que os requererem."}
            </label>
          </div>

          <Alerta
            tipo={TipoAlerta.danger}
            ref={this.alerta}
          />

          <Botao
            onClick={this.props.Avancar}
            titulo={"Continuar"}
            icone={"angle-double-right"}
            iconeDireita
            desativado={!this.state.checked}
          />
        </Form>
      </Box>
    );
  }
}